






























































































import { defineComponent } from '@vue/composition-api';

import Persons from '@/components/Persons.vue';

interface Person {
  name: string;
  email?: string;
  image: string;
  rank: string;
}

export default defineComponent({
  name: 'ProfileLdf',
  // props: {
  // },
  components: {
    Persons
  },
  setup: () => {
    const personsLdf: Person[] = [
      {
        name: 'Frank Becker',
        email: 'ldf@fw-everswinkel.de',
        image: require('@/assets/profile_ldf.jpg'),
        rank: 'Leiter der Feuerwehr'
      },
      {
        name: 'Martin Hülsmann',
        email: 'stellvldf@fw-everswinkel.de',
        image: require('@/assets/profile_stvldf.jpg'),
        rank: 'Stellv. Leiter der Feuerwehr'
      },
      {
        name: 'Manuel Kortenjan',
        email: 'stellvldf@fw-everswinkel.de',
        image: require('@/assets/profile_stvldf_2.png'),
        rank: 'Stellv. Leiter der Feuerwehr'
      }
    ];

    const personsEvZf: Person[] = [
      {
        name: 'Markus Averbeck',
        email: 'zf-ev@fw-everswinkel.de',
        image: require('@/assets/profile_ldf_ev_zf.jpeg'),
        rank: 'Zugführer'
      },
      {
        name: 'Steffen Weinhold',
        email: 'stellvzf-ev@fw-everswinkel.de',
        image: require('@/assets/profile_ldf_ev_zf_stv1.png'),
        rank: 'Stellv. Zugführer'
      },
      {
        name: 'Marcel Vetterle',
        email: 'stellvzf-ev@fw-everswinkel.de',
        image: require('@/assets/profile_ldf_ev_zf_stv2.png'),
        rank: 'Stellv. Zugführer'
      }
    ];

    const personsAvZf: Person[] = [
      {
        name: 'Alexander Wiesmann',
        email: 'zf-alv@fw-everswinkel.de',
        image: require('@/assets/profile_ldf_al_zf.jpeg'),
        rank: 'Zugführer'
      },
      {
        name: 'Frederick Schröder',
        email: 'stellvzf-alv@fw-everswinkel.de',
        image: require('@/assets/profile_ldf_al_zf_stv1.jpeg'),
        rank: 'Stellv. Zugführer'
      }
    ];
    return {
      personsLdf,
      personsEvZf,
      personsAvZf
    };
  }
});
